import { foundation } from '../../../ui';

/**
 * Shared skeleton tokens for the role dashboard skeletons. Role-specific clusters live in the
 * sibling per-role files; only pieces used by 2+ skeletons belong here. Surfaces are always white
 * (see CLAUDE.md parity rule).
 */

export const rd = foundation.radii;
